import React, { useState } from "react";

const templates = [
  {
    id: 1,
    name: "Curtains Installation",
    tasks: [
      { id: 1, name: "Measure Window Dimensions" },
      { id: 2, name: "Procure Materials" },
      { id: 3, name: "Install Curtains" },
    ],
  },
  {
    id: 2,
    name: "Office Furnishing",
    tasks: [
      { id: 1, name: "Design Layout" },
      { id: 2, name: "Procure Furniture" },
      { id: 3, name: "Assemble Furniture" },
    ],
  },
];

function AddWorkOrderModal({ onClose, onSave }) {
  const [name, setName] = useState("");
  const [priority, setPriority] = useState("Medium");
  const [dueDate, setDueDate] = useState("");
  const [tasks, setTasks] = useState([]);
  const [template, setTemplate] = useState(null);

  const handleTemplateChange = (templateId) => {
    const selectedTemplate = templates.find((t) => t.id === parseInt(templateId, 10));
    if (selectedTemplate) {
      setTasks(
        selectedTemplate.tasks.map((task) => ({
          ...task,
          dependency: null,
          status: "Pending",
        }))
      );
      setTemplate(selectedTemplate);
    }
  };

  const handleAddTask = () => {
    const newTask = { id: tasks.length + 1, name: "", dependency: null, status: "Pending" };
    setTasks([...tasks, newTask]);
  };

  const handleSave = () => {
    if (!name.trim()) {
      alert("Work order name is required.");
      return;
    }

    onSave({
      name,
      priority,
      dueDate,
      tasks,
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-3xl h-[calc(100vh-4rem)] rounded-md shadow-lg flex flex-col">
        {/* Header */}
        <div className="sticky top-16 bg-gray-100 border-b p-4 z-10">
          <h2 className="text-xl font-bold text-gray-800">Add Work Order</h2>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {/* Work Order Details */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Work Order Name</label>
            <input
              type="text"
              className="w-full p-2 mt-1 border rounded"
              placeholder="Work Order Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Priority</label>
              <select
                className="w-full p-2 mt-1 border rounded"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
              >
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Due Date</label>
              <input
                type="date"
                className="w-full p-2 mt-1 border rounded"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
              />
            </div>
          </div>

          {/* Add Tasks from Template */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Select Template</label>
            <select
              className="w-full p-2 mt-1 border rounded"
              onChange={(e) => handleTemplateChange(e.target.value)}
            >
              <option value="">Select</option>
              {templates.map((template) => (
                <option key={template.id} value={template.id}>
                  {template.name}
                </option>
              ))}
            </select>
          </div>

          {/* Task List */}
          <h3 className="text-lg font-bold text-gray-800">Tasks</h3>
          {tasks.map((task, index) => (
            <div key={index} className="p-4 border rounded bg-gray-50 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Task Name</label>
                <input
                  type="text"
                  className="w-full p-2 mt-1 border rounded"
                  placeholder="Task Name"
                  value={task.name}
                  onChange={(e) => {
                    const updatedTasks = [...tasks];
                    updatedTasks[index].name = e.target.value;
                    setTasks(updatedTasks);
                  }}
                />
              </div>

              <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700">Dependency</label>
                <select
                  className="w-full p-2 mt-1 border rounded"
                  value={task.dependency || ""}
                  onChange={(e) => {
                    const updatedTasks = [...tasks];
                    updatedTasks[index].dependency = parseInt(e.target.value, 10) || null;
                    setTasks(updatedTasks);
                  }}
                >
                  <option value="">None</option>
                  {tasks.map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700">Status</label>
                <select
                  className="w-full p-2 mt-1 border rounded"
                  value={task.status}
                  onChange={(e) => {
                    const updatedTasks = [...tasks];
                    updatedTasks[index].status = e.target.value;
                    setTasks(updatedTasks);
                  }}
                >
                  <option value="Pending">Pending</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                  <option value="Blocked">Blocked</option>
                </select>
              </div>
            </div>
          ))}

          {/* Add Task Button */}
          <button
            onClick={handleAddTask}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Add Task
          </button>
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-gray-100 border-t p-4 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddWorkOrderModal;